module.exports = __webpack_public_path__ + "static/media/line_graphic.3e0d8d31.svg";